module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/so-34b037a702aae22a75340594821f0476.svg";